export default function OrderIcon(props) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" {...props} xmlns="http://www.w3.org/2000/svg">
            <g id="Icon / UI / Arrow / switch vertical 1 / bold">
                <path fill={props?.fill || "#fff"} id="Icon" d="M16.4444 5V19.2222M16.4444 19.2222L12.8889 15.6667M16.4444 19.2222L20 15.6667M7.55556 19.2222V5M7.55556 5L4 8.55556M7.55556 5L11.1111 8.55556" stroke="#6CB6E3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>

    )
}
